exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ranking-dropdown[data-v-cd89fb92] input{width:300px;padding-right:2.5rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
